import React from 'react'
import illustration from '../../assests/illustration-1.svg'

const About = () => {
    return (
        <div className="flex flex-col md:flex-row-reverse items-center gap-20 w-5/6 md:w-3/4 mx-auto">
            <div className="w-full md:w-1/2 text-center md:text-left">
                <h1 className="text-2xl font-bold">Tentang TivAsh</h1>
                <p className="text-sm md:text-base md:w-4/5">Tivash app adalah aplikasi berbasis web yang ditujukan unutk pengelolaan sampah, dari pengambilan sampah oleh petugas, hingga pemilahan sampah yang dapat kita lakukan dengan bantuan Artificial Intelligence cerdas. Dengan konsep kantor yang memiliki banyak cabang jadi tivash group dapat menjangkau letak rumah Anda. </p>
            </div>
            <div className="w-full md:w-1/2">
                <img src={illustration} alt="illustration" />
            </div>
        </div>
    )
}

export default About
